import React, {useState, useEffect} from 'react';
import axios from "axios";
import Select from "react-select";
import Button from "react-bootstrap/Button";
import TextAreaWithTabs from "../../UI/TextAreaWithTabs/TextAreaWithTabs";
import apiUrl from "../../../shared/config";
import DeleteButton from "../../NewPattern/ExampleGamesInput/ExampleGameInputButtons/DeleteButton";
import {styleRedShadow, selectRedShadow} from "../../../utils/commonStyles";
import {validStringField} from "../../../utils/utils";

const PlayableConceptInput = ({playableConceptUpdate, playableConcept}) => {
    const [games, setGames] = useState([]);

    useEffect(() => {
        let isMounted = true; // Track if component is mounted

        const fetchGames = async () => {
            try {
                const response = await axios.get(`${apiUrl}Games/getPlayableConcepts`);
                if (isMounted) { // Only set state if component is mounted
                    setGames(response.data);
                }
            } catch (error) {
                if (isMounted) {
                    console.error("Failed to fetch games", error);
                }
            }
        };

        if (games.length === 0) {
            fetchGames();
        }

        return () => {
            isMounted = false; // Cleanup function to set isMounted to false
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // this is because I only want it to run on mount.

    const handleChange = (obj) => {
        playableConceptUpdate({...playableConcept, ...obj});
    };

    const handleDelete = () => {
        playableConceptUpdate({game_id: null, description: null});
    };

    const gameOptions = games.map(game => ({value: game.game_id, label: game.game_name}));

    const isPlayableConcept = playableConcept && gameOptions.some(option => option.value === playableConcept.game_id);


    return (
        <dl className="row">
            <dt className="col-sm-3"><label>Playable Concept</label></dt>
            {playableConcept && (playableConcept.game_id || playableConcept.description != null) ? (
                <dd className={'col-sm-9'}>
                    <div className={'example-games-block'}>
                        <Select
                            styles={selectRedShadow(isPlayableConcept || (!playableConcept.game_id && !validStringField(playableConcept.description)))}
                            className="example-games-select-semi-full"
                            options={gameOptions}
                            value={gameOptions.find(option => option.value === playableConcept.game_id) || null}
                            onChange={(val) => {
                                playableConceptUpdate({...playableConcept, game_id: val.value});
                            }}
                            placeholder="Select a playable concept"
                        />
                        <div style={{display: "flex", height: "35px",}}><DeleteButton onDelete={handleDelete}
                                                                                      message={'Are you sure you want to delete this playable concept?'}/>
                        </div>
                        <div className={'example-description'}>
                            <TextAreaWithTabs
                                style={styleRedShadow(validStringField(playableConcept.description) || (!playableConcept.game_id && !validStringField(playableConcept.description)))}
                                rows="4"
                                placeholder="Enter description for the playable concept..."
                                value={playableConcept.description}
                                onChange={(e) => handleChange({description: e.target.value})}
                            />
                        </div>
                    </div>
                </dd>
            ) : (
                <dd className="col-sm-9">
                    <Button className={"col-sm-12"} onClick={() => handleChange({game_id: null, description: ""})}
                            variant="outline-primary">Add Playable Concept</Button>
                </dd>
            )}
        </dl>
    );
};

export default PlayableConceptInput;
